import React from "react";
import styled from "styled-components";
import { colors } from "utils";

export const EmptyState = ({ message, description }) => {
  return (
    <Container>
      <Message>{message}</Message>
      {description && <Description>{description}</Description>}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
  text-align: center;
`;

const Message = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: ${colors.nightlyWoods700};
  margin-bottom: 0.5rem;
`;

const Description = styled.div`
  font-size: 0.875rem;
  color: ${colors.milkGlass900};
  font-style: italic;
`;
